<template lang="html">

  <section class="ficha -practica">

    <template v-if="!!data">
      <h2 class="ficha-title" :style="styles.colorBasic">Información del puesto</h2>
     
      <article class="group">
        <div class="contenedor-data w-100" v-if="!!data.idOferta">
          <h4 class="data-title" :style="styles.colorBasic">Id Oferta</h4>
          <p>{{data.idOferta}}</p>
        </div>

        <div class="contenedor-data w-100" v-if="!!data.puesto">
          <h4 class="data-title" :style="styles.colorBasic">Nombre oferta</h4>
          <p>{{data.puesto}}</p>
        </div>
         
        <div class="contenedor-data" v-if="!!data.fechaAlta">
          <h4 class="data-title" :style="styles.colorBasic">Fecha de alta</h4>
          <p>{{data.fechaAlta}}</p>
        </div>
        <div class="contenedor-data" v-if="!!data.fechaCaducidad">
          <h4 class="data-title" :style="styles.colorBasic">Fecha de caducidad</h4>
          <p>{{data.fechaCaducidad}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.nombreComercialEmpresa">
          <h4 class="data-title" :style="styles.colorBasic">Empresa</h4>
          <p>{{data.nombreComercialEmpresa}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.numeroPlazas">
          <h4 class="data-title" :style="styles.colorBasic">Número de plazas</h4>
          <p>{{data.numeroPlazas}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.horario">
          <h4 class="data-title" :style="styles.colorBasic">Horario</h4>
          <p>{{data.horario}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.fechaInicio">
          <h4 class="data-title" :style="styles.colorBasic">Fecha de inicio</h4>
          <p>{{data.fechaInicio}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.fechaFin">
          <h4 class="data-title" :style="styles.colorBasic">Fecha de fin</h4>
          <p>{{data.fechaFin}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.pais">
          <h4 class="data-title" :style="styles.colorBasic">País</h4>
          <p>{{data.pais}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.direccion">
          <h4 class="data-title" :style="styles.colorBasic">Dirección</h4>
          <p>{{data.direccion}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.localidad">
          <h4 class="data-title" :style="styles.colorBasic">Población/Provincia</h4>
          <p>{{data.localidad}} / {{ data.provincia }}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.empresa.sector">
          <h4 class="data-title" :style="styles.colorBasic">Sector</h4>
          <p>{{data.empresa.sector}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.areaFuncional">
          <h4 class="data-title" :style="styles.colorBasic">Área funcional</h4>
          <p>{{data.areaFuncional}}</p>
        </div>

        <div class="contenedor-data" v-if="!!data.modalidad">
          <h4 class="data-title" :style="styles.colorBasic">Modalidad</h4>
          <p>{{data.modalidad}}</p>
        </div>
      </article>

      <article class="group">
        <div class="contenedor-data -full" v-if="!!data.descripcionPuesto">
          <h4 class="data-title" :style="styles.colorBasic">Descripción del puesto</h4>
          <p>{{data.descripcionPuesto}}</p>
        </div>
      </article>
    </template>

  </section>

</template>

<script lang="js">
  import {
    mapGetters,
    mapActions
  } from 'vuex';

  import onlyArrow from '@/components/parts/icons/only-arrow';
  import arrowlink from '@/components/parts/icons/arrow-link';

  import addDocumentacion from '@/components/parts/add-documentacion';

  export default {
    name: 'ficha-practica',
    props: ['data'],
    data() {
      return {
        showadddocumentacion: false,
        uploadtype: '',
        documentacionPendiente: []
      }
    },
    mounted() {
    },
    methods: {
      

    },
    computed: {
      ...mapGetters({
        styles: 'getStyles',
        documentos: 'getDocumentos',
        uploaddoc: 'getCanUploadDocPracticas',
        brand: 'getBrand'
      }),

    },
    components: {
      'only-arrow': onlyArrow,
      'arrow-link': arrowlink,
      'add-documentacion': addDocumentacion
    }

  }
</script>

<style scoped lang="scss">
 .contact-section{
  display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #dedede;
    margin-bottom: 15px;
    padding-bottom: 15px;
 }

</style>


// WEBPACK FOOTER //
// src/components/views/ficha-datos-generales.vue